/* eslint-disable no-shadow */
/* eslint-disable */
/* eslint-disable max-lines-per-function */
import React, { useState, useEffect, useContext, useRef } from 'react';
import './scopeBE.scss';
import MagnifyingGlass from '../../../../../Assets/images/svg/dar_magnifying.svg';
import DataGridComponent from '../scopeDataGrid';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '../../../../../Assets/images/svg/dar_pencil.svg';
import RadioButtonGroup from './radioButtonGroup';
import { useLocation } from 'react-router-dom';
import NoDataFound from '../../../../../Assets/images/svg/dar_no_new_file.svg';
import FilterIcon from '../../../../../Assets/images/svg/dar_deal_transition_filter_icon.svg';
import DropDownArrow from '../../../../../Assets/images/svg/dar_drop_down_arrow.svg';

import FilterPanel from './filterPanel';
import { Button, TextField} from '@mui/material';
import BulkUpdate from '../ScopeFE/BulkUpdate/bulkUpdate';
import UseAxios from '../../../../../Api/http/http';
import { getCalculatedBaseEffort, getBEeffortDetails, saveBEeffortDetails, editBEeffortDetails, getBEeffort, getRequirementClarity, getTechnicalComplexity, getExternalIntegration, } from '../../../../../Api/request/dealEffort';
import { useSnackbar } from '../../../../../Components/Snackbar/snackBarProvider';
import { AuthContext } from '../../../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../../../Constants/modules';
import { v4 as uuidv4 } from 'uuid';
import Loader from '../../../../../Components/Loader';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { SCOPE_BE } from '../../../../../Constants/strings';

const ScopeBE = () => {
  const [rows, setRows] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [allRowsSelected, setAllRowsSelected] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  const [selectedRowsCount, setSelectedRowsCount] = useState(0);
  const [isFilterPanelVisible, setIsFilterPanelVisible] = useState(false);
  const [showBulkUpdate, setShowBulkUpdate] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [operationType, setOperationType] = useState('insert');
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const { userProfile } = useContext(AuthContext);
  const handleClose = () => setOpenDialog(false);
   const [loading, setLoading] = useState(true);
   const [isDisabled, setIsDisabled] = useState(true);
   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
   const headerCheckboxRef = useRef(null);
   

   useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
  
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const permission = userProfile?.permissions
  ? userProfile.permissions[MODULE_NAMES.DEAL_TRANSITION_EFFORT_ESTIMATION] || []
  : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  const [filterOptions, setFilterOptions] = useState([
    { name: 'BE Efforts', options: [] },
    { name: 'Requirement Clarity', options: [] },
    { name: 'Technical Complexity', options: [] },
    { name: 'External Integration', options: [] },
  ]);
  const [selectedFields, setSelectedFields] = useState({
    rowId: null,
    beEffortsId: null,
    requirementClarityId: null,
    technicalComplexityId: null,
    externalIntegrationId: null,
  });
  const { snackbarOpen } = useSnackbar();

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const query = useQuery();
  const DEAL_ID = query.get('id');

  useEffect(() => {
  const updateFilterOptions = async () => {
    setLoading(true);
    try {
      const [beEfforts, requirementClarity, technicalComplexity, externalIntegration] = await Promise.all([
        fetchFilterOptions(getBEeffort, 'BASE', true, 'baseEffort'),
        fetchFilterOptions(getRequirementClarity, 'CLARITY', true, 'clarityEffort'),
        fetchFilterOptions(getTechnicalComplexity, 'TECH', true, 'techEffort'),
        fetchFilterOptions(getExternalIntegration, 'INTEGRATION', true, 'externalIntegrationEffort')
      ]);

      setFilterOptions([
        { name: 'BE Efforts', options: beEfforts },
        { name: 'Requirement Clarity', options: requirementClarity },
        { name: 'Technical Complexity', options: technicalComplexity },
        { name: 'External Integration', options: externalIntegration },
      ]);
    } catch (error) {
      console.error('Error fetching filter options:', error);
    }
  };

  updateFilterOptions();
}, []);

  useEffect(() => {
    if (filterOptions.length > 0) {
      fetchRows();
    }
  }, [filterOptions]);

  useEffect(() => {
    if (isEdit) {
      setIsEdit(false);
    }
    setAllRowsSelected(false);
  }, [rows]);

  useEffect(() => {
    if (headerCheckboxRef.current) {
      const isIndeterminate = selectedRowIds.length > 0 && selectedRowIds.length < rows.length;
  
      headerCheckboxRef.current.indeterminate = isIndeterminate;
      headerCheckboxRef.current.checked = selectedRowIds.length === rows.length; 
      
      setIndeterminate(isIndeterminate);
      setAllRowsSelected(selectedRowIds.length === rows.length);
    }
  }, [selectedRowIds, rows.length]);
  
  
  useEffect(() => {
    const { rowId,beEffortsId, requirementClarityId, technicalComplexityId, externalIntegrationId } =
      selectedFields;
  
    if (rowId && beEffortsId && requirementClarityId && technicalComplexityId && externalIntegrationId) {
      fetchCalculatedEffort(beEffortsId, requirementClarityId, technicalComplexityId, externalIntegrationId,rowId);
    }
  }, [selectedFields]);
  
  const fetchCalculatedEffort = async (beEffortsId, requirementClarityId, technicalComplexityId, externalIntegrationId,rowId) => {
    try {
      const response = await UseAxios(
        getCalculatedBaseEffort(beEffortsId, requirementClarityId, technicalComplexityId, externalIntegrationId)
      );
      if (response?.data) {
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === rowId
              ? { ...row, beEfforts1: `${response?.data?.roundedOverallEffort} day(s)` }
              : row
          )
        );
      }
    } catch (error) {
      console.error('Error fetching base effort:', error);
    }
  };

  const fetchFilterOptions = async (apiFunc, type, active, effortName) => {
    try {
      const response = await UseAxios(apiFunc(type, active));
      if (response.data?.data?.[effortName]) {
        return response.data.data?.[effortName].map((item) => ({
          id: item.id,
          value: item.name,
          label: item.name,
        }));
      } else {
        console.error('Failed to fetch options');
        return [];
      }
    } catch (error) {
      console.error('Error fetching options:', error);
      return [];
    }
  };

  const filterByName = (filterOptions, filterName) => {
    return filterOptions.find((f) => f.name === filterName);
  }

  const findOptionById=(options, field)=>{
    return options.find((opt) => opt.id === field.id);
  }

  const fetchRows = async () => {
    try {
      setLoading(true);
      const response = await UseAxios(getBEeffortDetails(DEAL_ID));
  
      const sortedRows = response.data.dealBeEfforts
        .map((item) => {
          const getLabelById = (filterName, field) => {
            if (!field) return "N/A";
            const filter = filterByName(filterOptions, filterName);
            const matchedOption = findOptionById(filter.options, field);
            return matchedOption ? matchedOption.value : '';
          };
  
          return {
            id: item.id,
            checkbox: false,
            microservice: item.microservice,
            endpointDetails: item.endpoint,
            inScope: item.in_scope,
            beEfforts: getLabelById("BE Efforts", item.effortComplexity),
            requirementClarity: getLabelById("Requirement Clarity", item.requirementClarity),
            technicalComplexity: getLabelById("Technical Complexity", item.technicalComplexity),
            externalIntegration: getLabelById("External Integration", item.externalIntegration),
            beEfforts1: `${item.be_effort_day} day(s)`,
            beEffortsOverride: item.be_effort_override,
            screenConsumed: item.screen_consumed,
            isEditing: false,
          };
        })
        .sort((a, b) => b.id - a.id) 
  
        .map((item, index) => ({
          ...item,
          srNo: index + 1,
        }));
  
      setRows(sortedRows);
    } catch (error) {
      console.error("Error fetching rows:", error);
    }
    finally {
      setLoading(false);
    }
  };
  

  const saveRow = async (row, operationType) => {
    const id = row.id;
    const payload = {
      deal_id: DEAL_ID,
      microservice: row.microservice,
      endpoint: row.endpointDetails,
      in_scope: row.inScope,
      be_effort_complexity: row.beEffortsId,
      requirement_clarity: row.requirementClarityId,
      technical_complexity: row.technicalComplexityId,
      external_integration: row.externalIntegrationId,
      be_effort_day: parseInt(row.beEfforts1) || 0,
      be_effort_override: parseInt(row.beEffortsOverride) || 0,
      screen_consumed: parseInt(row.screenConsumed) || 0,
    };
  
    if (operationType === "update") {
      payload.id = id; 
    }
  
    try {
      await UseAxios(
        operationType === "insert" ? saveBEeffortDetails(payload) : editBEeffortDetails(payload)
      );
       snackbarOpen(SCOPE_BE.SUCCESS_MESSAGE, "success");
      setRows((prevRows) =>
        prevRows.map((row) =>
          row.id === id ? { ...row, isEditing: false, isEdit: false } : row
        )
      );
      await fetchRows();
    } catch (error) {
      console.error(error);
    }
  };

  const handleEditClick = () => {
    setOpenDialog(true);
    setShowBulkUpdate(true);
  };

  const handleSearch = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };

  const handleSelectAll = () => {
    if (indeterminate) {
      // If it's in indeterminate state, deselect only selected rows
      const updatedRows = rows.map((row) =>
        selectedRowIds.includes(row.id) ? { ...row, checkbox: false } : row
      );
      setRows(updatedRows);
      setSelectedRowIds([]);
      setSelectedRowsCount(0);
      setAllRowsSelected(false);
      setIndeterminate(false);
    } 
    else if(selectedRowIds.length === rows.length) {
      // If all are selected, uncheck everything
      setAllRowsSelected(false);
      setSelectedRowIds([]);
      setSelectedRowsCount(0);
      setRows(rows.map(row => ({ ...row, checkbox: false })));
    } 
    else {
      // Normal select all / deselect all behavior
      const checked = !allRowsSelected;
      const updatedRows = rows.map((row) => ({ ...row, checkbox: checked }));
      setRows(updatedRows);
      const selectedIds = checked ? updatedRows.map((row) => row.id) : [];
      setSelectedRowIds(selectedIds);
      setSelectedRowsCount(selectedIds.length);
      setAllRowsSelected(checked);
      setIndeterminate(false);
    }
  };

  const handleRowCheckboxChange = (id) => {
    const updatedRows = rows.map((row) =>
      row.id === id ? { ...row, checkbox: !row.checkbox } : row
    );
    setRows(updatedRows);
    const selectedIds = updatedRows.filter((row) => row.checkbox).map((row) => row.id);
    setSelectedRowIds(selectedIds);
    setSelectedRowsCount(selectedIds.length);
    
    if (selectedIds.length === rows.length) {
      setAllRowsSelected(true);
      setIndeterminate(false);
    } else if (selectedIds.length === 0) {
      setAllRowsSelected(false);
      setIndeterminate(false);
    } else {
      setAllRowsSelected(false);
      setIndeterminate(true);
    }
  };

  const toggleFilterPanel = () => {
    setIsFilterPanelVisible(!isFilterPanelVisible);
  };  

  const handleAddRow = () => {
    const newRow = {
      id: uuidv4(),
      checkbox: false,
      srNo: rows.length + 1,
      microservice: '',
      endpointDetails: '',
      inScope: false,
      beEfforts: '',
      requirementClarity: '',
      technicalComplexity: '',
      externalIntegration: '',
      beEfforts1: '0 day(s)',
      beEffortsOverride: '',
      screenConsumed: '',
      isEditing: true,
      rowHeight: 180,
      isEdit: false,  
    };
    const updatedRows = [newRow, ...rows].map((row, index) => ({
      ...row,
      srNo: index + 1,
    }));

    setRows(updatedRows);
    setOperationType('insert');
  };

  const handleInputChange = (e, id, field) => {
    const filterGroup = filterOptions.find(
      (f) => f.name.toLowerCase().replace(/\s+/g, '') === field.toLowerCase()
    );

    let selectedOption = null;
    if (filterGroup) {
      selectedOption = filterGroup.options.find((opt) => opt.value === (e.target.value || 'low'));
    }
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id
          ? {
            ...row,
            [field]: field === 'inScope' ? e.target.checked : (e.target.value),
            ...(filterGroup && { [`${field}Id`]: selectedOption?.id || null }),
          }
          : row
      )
    );
    setSelectedFields((prev) => ({
      ...prev,
      rowId: id,
      [field + "Id"]: selectedOption?.id || null
    }));
  };

  const handleSave = (id) => {
    setRows((prevRows) =>
      prevRows.map((row) => (row.id === id ? processRow(row) : row))
    );
  };
  
  const processRow = (row) => {
    const updatedRow = { ...row };
  
    if (isRowInvalid(updatedRow)) {
      snackbarOpen("Fill the required fields", "warning");
      return row;
    }
  
    fillEmptyFields(updatedRow);
  
    saveRow(updatedRow, operationType);
    return updatedRow;
  };
  
  const isRowInvalid = (row) => {
    return !row.microservice.trim() && !row.endpointDetails.trim();
  };
  
  const fillEmptyFields = (row) => {
    ["beEfforts", "requirementClarity", "technicalComplexity", "externalIntegration"].forEach((field) => {
      if (!row[field] || row[field].trim() === "") {
        row[field] = "N/A";
      }
    });
  };
  

  const handleCancel = (id) => {
    setRows((prevRows) =>
      prevRows.some((row) => row.isEdit)
        ? // If the row is in editing mode, restore the original data
          prevRows.map((row) =>
            row.id === id
              ? { ...row.originalData, isEditing: false, isEdit: false }
              : row
          )
        : // Otherwise, remove the row and reassign Sr. No
          prevRows
            .filter((row) => row.id !== id)
            .map((row, index) => ({
              ...row,
              srNo: index + 1, // Reassign Sr. No sequentially
            }))
    );
  };

  const handleEdit = async (id) => {
    setOperationType('update');
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, isEditing: true, isEdit: true, originalData: { ...row } } : row
      )
    );
  };

  const renderMobileActionIcon = (params) => {
    if (params.row.isEditing) {
      return null;
    }
    return (
      <div className="mobile-action-icons">
        <button
          className="role-action-edit-icon"
          aria-label="Edit"
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: !hasAccess('update') || params.row.isEditing  ? 'not-allowed' : 'pointer',
            opacity: !hasAccess('update') || params.row.isEditing  ? 0.4 : 1,
          }}
          onClick={() => handleEdit(params.row.id)}
          disabled={!hasAccess('update') || params.row.isEditing}
          
        >
          <img src={EditIcon} alt="Edit" />
        </button>
      </div>
    )
  };

  const preventNonNumericInput = (e) => {
    if (!/^\d$/.test(e.key) && !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(e.key)) {
      e.preventDefault();
    }
  };
  
  const saveCancelButtons = (rowId) => (
    <div className="save-and-cancel">
      <Button
        className="save-button"
        variant="contained"
        sx={{ minWidth: "10px", padding: "10px", paddingRight: "0px" }}
        onClick={() => handleSave(rowId)}
        startIcon={<CheckIcon />}
      />
      <Button
        className="cancel-button"
        variant="outlined"
        sx={{ minWidth: "10px", padding: "10px", paddingRight: "0px",  }}
        onClick={() => handleCancel(rowId)}
        startIcon={<ClearIcon />}
      />
    </div>
  );
  

  const columns = [
    {
      field: "checkbox",
      headerName: (
        <input
          id="select-all-checkbox"
          ref={headerCheckboxRef}
          type="checkbox"
          className="check-box-css"
          checked={allRowsSelected}
          onChange={handleSelectAll}
        />
      ),
      width: 55,
      renderCell: (params) => (
        <input
          type="checkbox"
          className="check-box-css"
          checked={params.row.checkbox}
          onChange={() => handleRowCheckboxChange(params.row.id)}
        />
      ),
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'srNo',
      headerName: 'S.No.',
      width: 80,
    sortable: false,
    disableColumnMenu: true,
    },
    {
      field: 'microservice',
      headerName: 'Microservice',
      width: 165,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <TextField
              defaultValue={row.microservice}
              onChange={(e) => handleInputChange(e, row.id, "microservice")}
              onKeyDown={(e) => e.stopPropagation()}
              className='text-box-css'
              variant="outlined"
              size="small"
            />
              {isMobile && row.isEditing && saveCancelButtons(row.id)}
            </div>
        ) : (
          <label className='saved-value'>{row.microservice}</label>
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
      field: 'endpointDetails',
      headerName: 'EP Details',
      width: 130,
      renderCell: ({ row }) =>
        row.isEditing ? (
            <TextField
              defaultValue={row.endpointDetails}
              onChange={(e) => handleInputChange(e, row.id, 'endpointDetails')}
              onKeyDown={(e) => e.stopPropagation()}
              className='text-box-css'
              variant="outlined"
              size="small"
            />
        ) : (
          <label className='saved-value'>{row.endpointDetails}</label>
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
      field: 'inScope',
      headerName: 'In Scope?',
      width: 110,
      renderCell: (params) => (
        <input
          type="checkbox"
          className='check-box-css'
          checked={params.row.inScope}
          disabled={!params.row.isEditing}
          onChange={(e) => handleInputChange(e, params.row.id, 'inScope')}
        />
      ),
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'beEfforts',
      headerName: 'BE Efforts',
      width: 120,
      renderCell: (params) =>
        params.row.isEditing ? (
          <RadioButtonGroup
            options={filterOptions.find((f) => f.name === 'BE Efforts').options}
            value={params.row.beEfforts}
            onChange={(e) => handleInputChange(e, params.row.id, 'beEfforts')}
          />
        ) : (
          <label className='saved-value'>{params.row.beEfforts}</label>
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
      field: 'requirementClarity',
      headerName: 'Req. Clarity',
      width: 130,
      renderCell: (params) =>
        params.row.isEditing ? (
          <RadioButtonGroup
            options={
              filterOptions.find((f) => f.name === 'Requirement Clarity').options
            }
            value={params.row.requirementClarity}
            onChange={(e) =>
              handleInputChange(e, params.row.id, 'requirementClarity')
            }
          />
        ) : (
          <label className='saved-value'>{params.row.requirementClarity}</label>
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
      field: 'technicalComplexity',
      headerName: 'Tech Complex.',
      width: 160,
      renderCell: (params) =>
        params.row.isEditing ? (
          <RadioButtonGroup
            options={
              filterOptions.find((f) => f.name === 'Technical Complexity').options
            }
            value={params.row.technicalComplexity}
            onChange={(e) =>
              handleInputChange(e, params.row.id, 'technicalComplexity')
            }
          />
        ) : (
          <label className='saved-value'>{params.row.technicalComplexity}</label>
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
      field: 'externalIntegration',
      headerName: 'Ext Integration',
      width: 160,
      renderCell: (params) =>
        params.row.isEditing ? (
          <RadioButtonGroup
            options={
              filterOptions.find((f) => f.name === 'External Integration').options
            }
            value={params.row.externalIntegration}
            onChange={(e) =>
              handleInputChange(e, params.row.id, 'externalIntegration')
            }
          />
        ) : (
          <label className='saved-value'>{params.row.externalIntegration}</label>
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
      field: 'beEfforts1',
      headerName: 'BE Efforts',
      width: 110,
      renderCell: (params) => <label className='saved-value'>{params.row.beEfforts1}</label>,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'beEffortsOverride',
      headerName: 'B.E Override',
      width: 130,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
          <TextField
            defaultValue={row.beEffortsOverride}
            onChange={(e) => handleInputChange(e, row.id, 'beEffortsOverride')}
            onKeyDown={(e) => {
              e.stopPropagation(); 
              preventNonNumericInput(e); 
            }}
            className='text-box-css'
            variant="outlined"
            size="small"
          />
           {!isMobile && row.isEditing && saveCancelButtons(row.id)}
         </div>
          
        ) : (
          <label className='saved-value'>{row.beEffortsOverride}</label>
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
      field: 'screenConsumed',
      headerName: 'Scrn. consumed',
      width: 155,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <TextField
            defaultValue={row.screenConsumed}
            onChange={(e) => handleInputChange(e, row.id, 'screenConsumed')}
            onKeyDown={(e) => {
              e.stopPropagation(); 
              preventNonNumericInput(e); 
            }}
            className='text-box-css'
            variant="outlined"
            size="small"
        />
        ) : (
          <label className='saved-value'>{row.screenConsumed}</label>
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      width: 70,
      renderCell: (params) => renderMobileActionIcon(params),
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const filteredRows = searchText
    ? rows.filter((row) =>
      Object.values(row).some((value) =>
        (value ? value.toString() : '').toLowerCase().includes(searchText)
      )
    )
    : rows;

  const sortFilterColumns = [
    columns[1].field,
    columns[2].field,
    columns[3].field,
    columns[4].field,
    columns[5].field,
    columns[6].field,
    columns[7].field,
    columns[8].field,
    columns[9].field,
    columns[10].field,
    columns[11].field,
  ];

  return (
    <div className="scope-be-outer-layer">
        {loading ? (
      <Loader /> 
    ) : (
      <>
      <div className="scope-be-map">
        <div className="scope-be-search-and-buttons">
          <div className="scope-be-search">
            <img src={MagnifyingGlass} alt="Search" />
            <input
              id="scope-be-search-input"
              type="text"
              placeholder="Search..."
              onChange={handleSearch}
            />
          </div>
          <div className="scope-be-buttons">
            {selectedRowsCount > 0 ? (
              <div className='filter-button-container'>
                <span style={{ color: 'black' }}>{selectedRowsCount} Issue Selected </span>
                <span style={{ color: '#CAC4CF' }}>|</span>
              
                <Button
                  className={`save-and-cancel-button ${!hasAccess('update') ? 'disabledButton' : 'enabledButton'}`}
                  variant="text"
                  style={{ color: '#6B5CE8' }}
                  onClick={() => handleEditClick()}
                  disabled={!hasAccess('update')}
                >
                  <img src={EditIcon} alt="Edit" style={{ height: '15px', marginRight: '5px' }} />
                  <div>Bulk Edit</div>
                </Button>
                {showBulkUpdate && <BulkUpdate open={openDialog} handleClose={handleClose} selectedIds={selectedRowIds} filterOptions={filterOptions} fetchRows={fetchRows} type='BE'/>}
              </div>
            ) : (
              <div className="scope-be-filter-and-add-button">
                <Button
                  className='save-and-cancel-button'
                  variant="text"
                  style={{ color: '#6B5CE8', display: 'none' }}
                  onClick={() => toggleFilterPanel()}
                  disabled={isDisabled}
                >
                  <img
                    src={FilterIcon}
                    style={{ marginRight: '5px' }}
                    alt="Filter"
                  />
                  <div>Filter</div>
                  <img
                    src={DropDownArrow}
                    style={{ marginLeft: '5px', marginRight: '20px' }}
                    alt="Dropdown arrow"
                  />
                </Button>
                {isFilterPanelVisible && (
                  <div className="filter-panel-wrapper">
                    <FilterPanel />
                  </div>
                )}
                <Button
                variant="contained"
                label="Add"
                onClick={handleAddRow}
                startIcon={<AddIcon />}
                style={{
                  backgroundColor: '#6b5ce8', 
                  opacity: !hasAccess('create') ? 0.5 : 1, 
                  cursor: !hasAccess('create') ? 'not-allowed' : 'pointer', 
                  color: 'white', 
                }}
                
                disabled={!hasAccess('create')}
                
                >Add</Button>
              </div>
            )}
          </div>
        </div>
        <div className="data-grid-container">
          <DataGridComponent
            dataRows={filteredRows}
            dataColumns={columns}
            pageSize={10}
            isFilteredRows={filteredRows}
            sortFilterColumns={sortFilterColumns}
            isEdit={isEdit}
            gridCheckbox={false}
            onRowSelectionChange={() => { }}
            dataGridCss=""
            checkboxDisabled={false}
            rowHeight={filteredRows.length === 0 && 180}
            noDataImage={NoDataFound}
          />
        </div>

      </div>
      </>
    )}
    </div>
  );
};
export default ScopeBE;